type HomeRemoteImage = {
  src: string;
  width: number;
  height: number;
};

export const HOME_ASSET_BASE_URL =
  "https://cdn.inito.com/inito_website/home/assets";

export function homeAsset(path: string) {
  return `${HOME_ASSET_BASE_URL}/${path}`;
}

export const homeAssets = {
  hero: {
    desktop: homeAsset("hero/hero_desktop_new.png"),
    mobile:
      "https://cdn.inito.com/inito_website/home/assets/hero/hero_mobile_new_3.png",
  },
  pitch: {
    illustration: {
      src: homeAsset("pitch_2.png"),
      width: 1800,
      height: 1725,
    } satisfies HomeRemoteImage,
  },
  confirm: {
    frames: [
      {
        src: homeAsset("confirm/frame-low.png"),
        width: 1210,
        height: 1130,
      },
      {
        src: homeAsset("confirm/frame-high.png"),
        width: 1210,
        height: 1130,
      },
      {
        src: homeAsset("confirm/frame-peak.png"),
        width: 1210,
        height: 1130,
      },
      {
        src: homeAsset("confirm/frame-confirmed.png"),
        width: 1210,
        height: 1130,
      },
    ] satisfies HomeRemoteImage[],
  },
  track: {
    chart: homeAsset("track/chart.png"),
  },
  hormoneCharts: {
    frames: [
      {
        src: homeAsset("hormone-charts/frame_1.png"),
        width: 1428,
        height: 1352,
      },
      {
        src: homeAsset("hormone-charts/frame_2.png"),
        width: 1428,
        height: 1352,
      },
      {
        src: "https://cdn.inito.com/inito_website/home/assets/hormone-charts/frame_3.png",
        width: 1428,
        height: 1352,
      },
    ] satisfies HomeRemoteImage[],
  },
  mdjQuote: {
    desktop: homeAsset("expert-recommended/mdj_desktop.webp"),
    mobile: homeAsset("expert-recommended/mdj.webp"),
  },
  uniqueCycle: {
    pcos: homeAsset("unique-cycle/base-pcos.png"),
    tryingAfter35: homeAsset("unique-cycle/base-trying-after-35.png"),
    afterMiscarriage: homeAsset("unique-cycle/base-after-miscarriage.png"),
    irregularCycles: homeAsset("unique-cycle/base-irregular-cycles.png"),
    preIvf: homeAsset("unique-cycle/base-pre-ivf.png"),
  },
  spectralPrecision: {
    desktop: homeAsset("spectral-precision/device-visual-clean.png"),
    mobile:
      "https://cdn.inito.com/inito_website/home/assets/spectral-precision/precision_mobile_spectral.png",
  },
  expertRecommended: {
    drPero: homeAsset("expert-recommended/dr-pero-desktop.jpg"),
    featuredPoster: homeAsset("expert-recommended/mdj_desktop.webp"),
    mobileCard1: homeAsset("expert-recommended/mdj.webp"),
    mobileCard2: homeAsset("expert-recommended/mobile-card-2-bg.png"),
    mobileCard3:
      "https://cdn.inito.com/landing_page/section/recomended/doctor_2.webp",
    avatar1: homeAsset("expert-recommended/avatar-1.png"),
    avatar2: homeAsset("expert-recommended/avatar-2.svg"),
    youtubeIcon: homeAsset("expert-recommended/youtube.svg"),
  },
  community: {
    cards: [
      homeAsset("community/card-1.png"),
      homeAsset("community/card-2.png"),
      homeAsset("community/card-3.png"),
      homeAsset("community/card-4.png"),
      homeAsset("community/card-5.png"),
      homeAsset("community/card-6.png"),
      homeAsset("community/card-7.jpg"),
      homeAsset("community/card-8.jpg"),
      homeAsset("community/card-9.jpg"),
    ],
  },
  testimonials: {
    pcos1: homeAsset("testimonials/pcos_1.jpeg"),
    pcos2: homeAsset("testimonials/pcos_2.png"),
    pcos3: homeAsset("testimonials/pcos_3.jpeg"),
    ttc351: homeAsset("testimonials/ttc35_1.jpeg"),
    ttc352: homeAsset("testimonials/ttc35_2.jpg"),
    ttc353: homeAsset("testimonials/ttc35_3.jpg"),
    irregularCycles1: homeAsset("testimonials/ic_1.jpg"),
    irregularCycles2: homeAsset("testimonials/ic_2.jpeg"),
    irregularCycles3: homeAsset("testimonials/ic_3.jpeg"),
    postMiscarriage1: homeAsset("testimonials/pm_1.jpeg"),
    postMiscarriage2: homeAsset("testimonials/pm_2.jpg"),
    postMiscarriage3: homeAsset("testimonials/pm_3.jpeg"),
    preIvf1: homeAsset("testimonials/pre_ivf_1.jpg"),
    preIvf2: homeAsset("testimonials/pre_ivf_2.jpeg"),
    preIvf3: homeAsset("testimonials/pre_ivf_3.jpeg"),
  },
} as const;
